interface Props {
    className?: string;
}

export function CheckIcon({ className }: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 13 10" fill="none">
            <path
                d="M12.5001 2.25764C12.5016 2.35383 12.4831 2.44929 12.4457 2.53795C12.4084 2.6266 12.353 2.70653 12.2831 2.77264L6.67808 8.25764L5.62508 9.28764C5.55627 9.35639 5.47433 9.41059 5.38413 9.44701C5.29394 9.48343 5.19734 9.50133 5.10008 9.49964C5.00249 9.50165 4.90549 9.48391 4.81492 9.44748C4.72436 9.41105 4.6421 9.35668 4.57308 9.28764L3.52008 8.25764L0.717084 5.51464C0.647194 5.44853 0.591812 5.3686 0.554455 5.27995C0.517099 5.19129 0.498583 5.09583 0.500085 4.99964C0.500085 4.79764 0.572085 4.62564 0.717084 4.48464L1.77008 3.45464C1.83893 3.38559 1.921 3.33113 2.01138 3.29454C2.10176 3.25794 2.19859 3.23995 2.29608 3.24164C2.50308 3.24164 2.67808 3.31264 2.82308 3.45464L5.10008 5.68964L10.1781 0.712638C10.3181 0.572638 10.5081 0.496639 10.7051 0.500639C10.9111 0.500639 11.0871 0.570638 11.2311 0.712638L12.2841 1.74264C12.4261 1.87664 12.5041 2.06364 12.5011 2.25864L12.5001 2.25764Z"
                fill="currentColor"
            />
        </svg>
    );
}
